import { render, staticRenderFns } from "./dangerousGoodsStorageLocationTable.vue?vue&type=template&id=28f0b590"
import script from "./dangerousGoodsStorageLocationTable.vue?vue&type=script&lang=js"
export * from "./dangerousGoodsStorageLocationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports